export const formatAvg = (value) => {
  return value !== 0 ? parseFloat(value.replace(",", ".")).toFixed(2) : 0;
};
